import React, { useEffect, useReducer, useRef } from 'react';
import { Badge, Button } from '@themesberg/react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { getAllGames } from '../../../controller/api/game';
import Table from './partials/Table';
import FilterForm from './partials/FilterForm';
import RevenueStatistics from './partials/RevenueStatistics';
import { parseQuerySimple } from '../../../helper/urlHelper';
import { getTicketScope } from './ticketView';
import './ticket.css';

export const Context = React.createContext(null);
const statuses = [
  ['all', 'Tất cả', 'primary'], ['waiting-print', 'Đang xử lý', 'warning'],
  ['printed', 'Đã in', 'info'], ['waiting-reward', 'Chờ tính thưởng', 'secondary'],
  ['done', 'Hoàn thành', 'success'], ['deleted', 'Đã hủy', 'danger'],
];
export const todayInput = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
function queryFilter(search) {
  const q = parseQuerySimple(search);
  const lookup = Boolean(q.cartId || q.ticketId || q.gamePeriodId);
  const gameScope = getTicketScope(q);
  return {
    cartId: q.cartId || '', ticketId: q.ticketId || '', gamePeriodId: q.gamePeriodId || '', gameScope,
    gameId: gameScope === 'other' && q.gameId !== 'keno' ? q.gameId || '' : '',
    from: lookup ? '' : todayInput(), to: lookup ? '' : todayInput(), statusGroup: q.statusGroup || 'all',
    sortBy: 'createdAt', sortDirection: 'desc',
  };
}
function reducer(state, action) {
  switch (action.type) {
    case 'SUBMIT_FILTER': return { ...state, ...action.payload, isFilterLoading: true, filterSubmitCount: state.filterSubmitCount + 1 };
    case 'SET_GAME_SCOPE': return { ...state, gameScope: action.payload, gameId: '' };
    case 'SET_FILTER_LOADING': return { ...state, isFilterLoading: action.payload };
    case 'SET_STATUS_STATISTICS': return { ...state, statusStatistics: action.payload || {} };
    case 'SET_GAMES': return { ...state, games: action.payload || [] };
    case 'REFRESH_REVENUE_STATISTICS': return { ...state, revenueRefreshKey: state.revenueRefreshKey + 1 };
    default: return state;
  }
}
export default function Ticket() {
  const location = useLocation();
  const history = useHistory();
  const [cookies] = useCookies(['lottmekong']);
  const [state, dispatch] = useReducer(reducer, {
    ...queryFilter(location.search), phone: '', customerName: '', statusStatistics: {}, games: [],
    revenueRefreshKey: 0, isFilterLoading: false, filterSubmitCount: 0,
  });
  const lastSearchRef = useRef(location.search);
  useEffect(() => { document.title = 'Vé'; }, []);
  useEffect(() => {
    let active = true;
    getAllGames(cookies.lottmekong).then(response => {
      if (active && response?.data) dispatch({ type: 'SET_GAMES', payload: response.data });
    }).catch(error => console.error('Error loading games:', error));
    return () => { active = false; };
  }, [cookies.lottmekong]);
  useEffect(() => {
    if (lastSearchRef.current === location.search) return;
    lastSearchRef.current = location.search;
    dispatch({ type: 'SUBMIT_FILTER', payload: { ...queryFilter(location.search), phone: '', customerName: '', statusStatistics: {} } });
  }, [location.search]);
  useEffect(() => {
    if (!state.gameScope || lastSearchRef.current !== location.search) return;
    const q = new URLSearchParams(location.search);
    if (['keno', 'other'].includes(q.get('tab')) && q.get('tab') !== state.gameScope) return;
    if (q.get('tab') === state.gameScope) return;
    q.set('tab', state.gameScope);
    const search = `?${q.toString()}`;
    lastSearchRef.current = search;
    history.replace({ pathname: location.pathname, search });
  }, [state.gameScope, history, location.pathname, location.search]);
  const selectTab = (gameScope) => {
    if (gameScope === state.gameScope) return;
    const q = new URLSearchParams(location.search);
    ['cartId', 'ticketId', 'gamePeriodId', 'gameId', 'showDetail'].forEach(key => q.delete(key));
    q.set('tab', gameScope);
    const search = `?${q.toString()}`;
    lastSearchRef.current = search;
    history.replace({ pathname: location.pathname, search });
    dispatch({ type: 'SUBMIT_FILTER', payload: {
      gameScope, gameId: '', cartId: '', ticketId: '', gamePeriodId: '', statusStatistics: {},
      from: state.cartId || state.ticketId || state.gamePeriodId ? todayInput() : state.from,
      to: state.cartId || state.ticketId || state.gamePeriodId ? todayInput() : state.to,
    } });
  };
  return <Context.Provider value={{ state, dispatch }}>
    <div className="ticket-page">
      <div className="ticket-heading">
        <h4 className="mb-0">Vé</h4>
        <div className="ticket-game-tabs" role="group" aria-label="Nhóm trò chơi">
          {[['keno', 'Keno'], ['other', 'Vé khác']].map(([scope, label]) =>
            <button key={scope} type="button" aria-pressed={state.gameScope === scope}
              className={state.gameScope === scope ? 'active' : ''} onClick={() => selectTab(scope)}>{label}</button>)}
        </div>
      </div>
      <FilterForm />
      <RevenueStatistics />
      <div className="ticket-status-tabs" role="group" aria-label="Trạng thái vé">
        {statuses.map(([id, label, color]) => <Button key={id} size="sm"
          variant={state.statusGroup === id ? 'primary' : 'outline-light'} aria-pressed={state.statusGroup === id}
          onClick={() => { if (id !== state.statusGroup) dispatch({ type: 'SUBMIT_FILTER', payload: { statusGroup: id } }); }}>
          {label} <Badge bg={state.statusGroup === id ? 'light' : color} text={state.statusGroup === id ? 'dark' : undefined} className="ms-2">{state.statusStatistics[id] || 0}</Badge>
        </Button>)}
      </div>
      <Table />
    </div>
  </Context.Provider>;
}
